import { SITE } from "../config/site";

export default function ShippingPolicy() {
  return (
    <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
      <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#e46a2e]">Shipping policy</p>
        <h1 className="mt-2 text-3xl font-black tracking-tight text-slate-950">Delivery and pickup information</h1>

        <div className="mt-6 grid gap-4 md:grid-cols-2">
          <PolicyCard
            title="Delivery support"
            text="We coordinate delivery quickly within Nairobi and surrounding areas based on your order details and location."
          />
          <PolicyCard
            title="Store pickup"
            text={`You can also arrange pickup from ${SITE.locationTitle}, ${SITE.locationLine}.`}
          />
          <PolicyCard
            title="Order confirmation"
            text={`For urgent updates, contact us on ${SITE.phoneDisplay} or confirm through WhatsApp after checkout.`}
          />
          <PolicyCard
            title="Business hours"
            text={SITE.businessHoursDetailed}
          />
        </div>
      </div>
    </main>
  );
}

function PolicyCard({ title, text }) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-5">
      <h2 className="text-lg font-bold text-slate-950">{title}</h2>
      <p className="mt-2 whitespace-pre-line text-sm leading-6 text-slate-600">{text}</p>
    </div>
  );
}